 import axios from 'axios';

const API = axios.create({
  baseURL: '/api'
});

// Har request ke sath token bhejna
API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// Public - Approved Blogs WITH PAGINATION
export const getBlogs = async (page = 1, limit = 9) => {
  try {
    const response = await API.get(`/blogs?page=${page}&limit=${limit}`);
    return response.data; // { blogs: [], totalPages: 1 }
  } catch (error) {
    throw error.response?.data || { message: "Error fetching blogs" };
  }
};

// ADMIN - SAB BLOG - Dashboard ke liye
export const getAllBlogsAdmin = async (page = 1, limit = 100) => {
  try {
    const response = await API.get(`/blogs/admin/all?page=${page}&limit=${limit}`);
    return response.data; // { blogs: [], totalPages: 1 }
  } catch (error) {
    throw error.response?.data || { message: "Error fetching all blogs" };
  }
};

// User - Create Blog - Review ke liye
export const createBlogUser = async (blogData) => {
  try {
    const formData = new FormData();
    formData.append('title', blogData.title);
    formData.append('description', blogData.description);
    formData.append('category', blogData.category);
    formData.append('tags', blogData.tags);
    formData.append('authorName', blogData.authorName || "User");
    if (blogData.image) {
      formData.append('image', blogData.image);
    }
    const response = await API.post("/blogs/user", formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error creating blog" };
  }
};

// Admin - Create Blog - Direct Publish
export const createBlogAdmin = async (blogData) => {
  try {
    const formData = new FormData();
    formData.append('title', blogData.title);
    formData.append('description', blogData.description);
    formData.append('category', blogData.category);
    formData.append('tags', blogData.tags);
    formData.append('authorName', blogData.authorName || "Admin");
    if (blogData.image) {
      formData.append('image', blogData.image);
    }
    const response = await API.post("/blogs/admin", formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error creating blog" };
  }
};